import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import axios from 'axios'
import uploading from '../Photoset/uploading.png'
import './UpdateActivity.css'

function UpdateUser() {
    const { id } = useParams();
    const [image, setImage] = useState();
    const [name, setName] = useState('');
    const [date, setDate] = useState('');
    const [link, setLink] = useState('');
    const navigate = useNavigate();
    
    useEffect(() => {
        axios.get(`https://school-web-server-eight.vercel.app/getactivity/${id}`)
            .then(result => {
                const { name, date, link } = result.data;
                setName(name);
                setDate(date);
                setLink(link);
            })
            .catch(err => console.log(err));
    }, [id]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('date', date);
            formData.append('link', link);
            if (image && typeof image !== 'string') {
                formData.append('image', image);
            }

            await axios.put(`https://school-web-server-eight.vercel.app/updateactivity/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            navigate('/login/updateactivity');
        } catch (error) {
            console.error('Error during update:', error.response?.data || error.message);
        }
    };

    const inputRef = useRef(null);

    const handleImageClick = () => {
        inputRef.current.click();
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (!file || file.length === 0) {
            console.error("No file selected.");
            return;
        }
        const imgname = event.target.files[0].name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const img = new Image();
            img.src = reader.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.toBlob(
                    (blob) => {
                        const file = new File([blob], imgname, {
                            type: "image/png",
                            lastModified: Date.now(),
                        });

                        console.log(file);
                        setImage(event.target.files[0]);
                    },
                    "image/jpeg",
                    0.8
                );
            };
        };
    };

    return (
        <div className='activity-create'>
                <h2>อัพเดตกิจกรรม</h2>
                <form onSubmit={handleUpdate}>
                <div className='activity-create-info'>
                    <div className='ac-2'>
                        <div className='ac-2-text'><label htmlFor="">รูปภาพ</label></div>
                        <div className="image" onClick={handleImageClick} style={{ cursor: "pointer" }}>
                            <div className="imgupload">{image ? (<img src={URL.createObjectURL(image)} alt="" />) : (<img src={uploading} alt="" />)}</div>
                            <input
                                type="file"
                                ref={inputRef}
                                onChange={handleImageChange}
                                style={{ display: "none" }} />
                        </div>
                    </div>
                    <div className='ac-2'>
                        <div className='ac-2-text'><label htmlFor="">เรื่อง</label></div>
                        <input type="text" placeholder='เพิ่มชื่อเรื่อง' className='form-control' onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div className='ac-2'>
                        <div className='ac-2-text'><label htmlFor="">วันที่อัปโหลด</label></div>
                        <input type="date" className='form-control' onChange={(e) => setDate(e.target.value)} />
                    </div>
                    <div className='ac-2'>
                        <div className='ac-2-text'><label htmlFor="">เพิ่มลิงค์</label></div>
                        <input type="link" placeholder='เพิ่มลิงค์' className='form-control' onChange={(e) => setLink(e.target.value)} />
                    </div>
                    <button className='btn-success' type='submit'>อัพเดต</button>
                </div>
                </form>
            </div>
    )
}

export default UpdateUser